import React, { useState } from "react";
import axiosInstance from "../utils/axiosInstance";

const DonwloadModFileButton = ({
  fileId,
  fileName,
  status,
  price_status,
  isTable,
}) => {
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/files/${fileId}/download-mod-file`,
        {
          responseType: "blob",
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();

      link.parentNode.removeChild(link);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <div className={!isTable && "mt-6"}>
      {status === "PROCESSED" && price_status === "PAID" && (
        <button
          onClick={handleDownload}
          disabled={loading}
          className={`${
            !isTable && `bg-red-600 hover:bg-red-700 text-white`
          }   px-4 py-2 rounded-lg flex items-center gap-2`}
        >
          {isTable ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="size-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
              />
            </svg>
          ) : (
            <>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M3 4a2 2 0 012-2h10a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V4zm5 4a1 1 0 000 2h4a1 1 0 000-2H8z"
                  clipRule="evenodd"
                />
              </svg>
              {loading ? "Downloading..." : "Download Modified File"}
            </>
          )}
        </button>
      )}
    </div>
  );
};

export default DonwloadModFileButton;
